import { SellerFilter, MarketplaceFilter, CustomFilter } from "@/components/new-filters";
import { mapState } from 'vuex';
import FiltersFrame from "@/components/new-filters/FiltersFrame.vue";
import { EVENTS } from "@/utils";
export default {
  name: "DspFilters",
  components: {
    SellerFilter,
    MarketplaceFilter,
    FiltersFrame,
    CustomFilter
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.dsp_report.sellers_filter,
      marketplaces_filter: state => state.dsp_report.marketplaces_filter,
      campaigns: state => state.dsp_report.campaigns,
      line_items: state => state.dsp_report.line_items
    })
  },
  methods: {
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching sub filters for sellers...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_DSP_SELLERS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_DSP);
      }
    },
    async applyMarketplaces() {
      if (this.marketplaces_filter.isModified) {
        this.marketplaces_filter.apply();
        await window.$bus.trigger(EVENTS.REFRESH_DSP_MARKETPLACES_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_DSP);
      }
    },
    async applyCampaigns() {
      if (this.campaigns.isModified) {
        this.campaigns.apply();
        await window.$bus.trigger(EVENTS.REFRESH_DSP_CAMPAIGNS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_DSP);
      }
    },
    applyLineItems() {
      if (this.line_items.isModified) {
        this.line_items.apply();
        window.$bus.trigger(EVENTS.REFRESH_DSP);
      }
    }
  }
};